import React from "react";
import { Route, Routes } from "react-router-dom";
import StoreManagerDashboard from "../../pages/dashboard/StoreManagerDashboard";
import AuthorizeWarehouseRequisitions from "../../pages/StoresRequisition/AuthorizeWarehouseRequisition";
import SuppliedWarehouseRequisition from "../../pages/StoresRequisition/SuppliedWarehouseRequisition";

const StoreManagerRoutes = () => {
  return (
    <Routes>
      <Route path="dashboard" element={<StoreManagerDashboard />} />
      <Route
        path="requisition/pending"
        element={<AuthorizeWarehouseRequisitions />}
      />
      <Route
        path="requisition/supplied"
        element={<SuppliedWarehouseRequisition />}
      />
    </Routes>
  );
};

export default StoreManagerRoutes;
